import AlumniStoriesSection from './AlumniStoriesSection'
import StudentVoicesSection from './StudentVoicesSection'
import ParentTestimonialsPageContent from './ParentTestimonialsPageContent'

export default function StoryCardsSection({ type }) {
  switch (type) {
    case 'alumni':
      return <AlumniStoriesSection />
    case 'students':
      return <StudentVoicesSection />
    case 'parents':
      return <ParentTestimonialsPageContent />
    default:
      return null
  }
}
